import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import layoutReducer from "./layout";
import eventManagementReducer from "./eventManagement";
import settingReducer from "./setting";
import categoryReducer from "./category";

const store = configureStore({
  reducer: {
    auth: authReducer,
    layout: layoutReducer,
    eventManagement: eventManagementReducer,
    setting: settingReducer,
    category: categoryReducer,
  },
});

export default store;
